export default "__VITE_ASSET__DYNjpDxT__"